import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { ProfileSettingsService } from './services/shared/profile-settings/profile-settings.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectorRef, ViewChild, NgZone } from '@angular/core';
import { SocialMediaService } from './services/social-media/social-media.service';
import { FirebaseMessagingService } from './services/firebase-messaging/firebase-messaging.service';
import { LoaderService } from './modules/loader/services/loader/loader.service';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { LanguageService, english } from './services/shared/language/language.service';
import { SessionService } from './services/session/session.service';
import { LoginService } from './services/login/login.service';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatDrawer } from '@angular/material/sidenav';
import { jsonDeepParse, replaceAll } from './functions/shared-functions';
import { filter } from 'rxjs/operators';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

export const queryStringToJSON = (input) => {
  var pairs = input.split('&');
  var result = {};
  pairs.forEach(function (pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });

  return JSON.parse(JSON.stringify(result));
}

export const jsonToQueryString = (params) => {
  return Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

export function jsonParse(str) {
  try {
    if (typeof str == 'string')
      return JSON.parse(str);
    else
      return str;
  } catch (e) {
    //
    if (typeof str == 'object')
      return str;
    else
      return str;
  }
}


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [SocialMediaService, FirebaseMessagingService, TranslateService]
})
export class AppComponent implements OnInit {
  title = 'TALLINT';
  loader = false;
  current_language;
  current_route;
  labels;
  data;
  sidebar_ref: Function;
  closeSideNavRef: Function
  sidebar_width = '30%'
  @ViewChild("sideNav", { static: false }) sideNav: MatDrawer;
  @ViewChild('sideNav', { static: false }) sidebar: MatDrawer;
  public static tab_key: boolean = false;
  timeout: any;
  status_details: any = {
    status: 1,
    summary: 'Ready...'
  }
  portal_details: any = {};
  careerPortalConfig: any = {};
  customStyle: any = {};
  timer = -1;  
  is_session = 0;
  notificationSound;

  showNavbar = true;

  constructor(private fb: FirebaseMessagingService,
    public session_svc: SessionService,
    public login_service: LoginService,
    private loader_svc: LoaderService,
    private change_detector: ChangeDetectorRef,
    private translate: TranslateService,
    private language: LanguageService,
    private router: Router,
    private http: HttpClient,
    private profile_settings: ProfileSettingsService,
    private ng_zone: NgZone,
    private notification_srv: NotificationService




  ) {
    this.initFireBase();
    this.loader_svc.showLoader();
    translate.setDefaultLang('1');
    let lng;

    if (localStorage.getItem('language')) {
      try {
        lng = JSON.parse(localStorage.getItem('language'));
        translate.use(lng.lng_id);
      }
      catch (err) {

        lng = english;
      }
    }
    else {
      lng = english;
      translate.use('1');
    }

    this.language.setCurrentLanguage(lng);
    this.languageChanged(lng);

    this.translate.onTranslationChange.subscribe((event: TranslationChangeEvent) => {
      this.setTextDirection();
    });

    this.notification_srv.notification.subscribe(res => {

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (res && res['success']) {
        // this.status_details = res;
        // this.status_details['status'] = 1;
        try {
          let el = document.getElementById('tm-popup-notification-window');
          el.style.display = 'block';
          el.innerHTML = res['summary'];
        }
        catch (err) {
        }
        this.createAlert(res['title'], res['summary'], res['details'], res['severity'], res['dismissible'], res['autoDismiss'], res['appendToId'])
        this.timeout = setTimeout(() => {
          // this.status_details = {
          //   summary: 'Ready...'
          // }
          try {
            let el = document.getElementById('tm-popup-notification-window');
            el.style.display = 'none';
            el.innerHTML = ''
          }
          catch (err) {
          }
          // this.status_details['status'] = 3;
          clearTimeout(this.timeout);
        }, this.status_details.autoDismiss || 5000)
      }
      else if (res && !res['success']) {
        // this.status_details = res;
        // this.status_details['status'] = 2;
        try {
          let el = document.getElementById('tm-popup-notification-window')
          el.style.color = "var(--js-red)"
          el.style.display = 'block'
          el.innerHTML = res['summary'];
        }
        catch (err) {
        }
        this.createAlert(res['title'], res['summary'], res['details'], res['severity'], res['dismissible'], res['autoDismiss'], res['appendToId'])
        this.timeout = setTimeout(() => {
          try {
            let el = document.getElementById('tm-popup-notification-window');
            el.innerHTML = ""
            el.style.color = "var(--js-red)";
            el.style.display = 'none'
          }
          catch (err) {
          }
          clearTimeout(this.timeout);
        }, this.status_details.autoDismiss || 5000)
        console.log(res)
      }
    })
    // this.language.getAllLabels(6).subscribe(res => {
    //   try {
    //     if (typeof res == 'string') {
    //       let str = res;
    //       str = str.replace(/[\\]+\\"/g, '\\"');
    //       // str = str.replace(/\\"/g, '"');
    //       // str = str.replace(/TALLINTHC/g, '\\"');
    //       str = str.replace(/\\&amp;#34;/g, '');
    //       str = str.replace(/[\t]/g, "    ");
    //       // str = escape(str);
    //       // str = decodeURIComponent(str);
    //
    //       this.labels = jsonParse(str);
    //
    //     }
    //     else {
    //       this.labels = res;
    //     }

    //   } catch (error) {
    //
    //
    //     if (typeof res == 'object')
    //       this.labels = res;
    //     else
    //       this.labels = res;
    //   }
    // })
    // if (environment['module_code'] && environment['module_code'] != 6) {
    //   this.language.getAllLabels(environment['module_code']).subscribe(res => {
    //     let labels;
    //     try {
    //       if (typeof res == 'string') {
    //         let str = res;
    //         str = str.replace(/[\\]+\\"/g, '\\"');
    //         // str = str.replace(/\\"/g, '"');
    //         // str = str.replace(/TALLINTHC/g, '\\"');
    //         str = str.replace(/\\&amp;#34;/g, '');
    //         str = str.replace(/[\t]/g, "    ");
    //         // str = escape(str);
    //         // str = decodeURIComponent(str);
    //
    //         labels = jsonParse(str);
    //
    //       }
    //       else {
    //         labels = res;
    //       }

    //     } catch (error) {
    //
    //
    //       if (typeof res == 'object')
    //         labels = res;
    //       else
    //         labels = res;
    //     }

    //     //
    //     labels = Object.assign(this.labels, labels)
    //
    //     this.translate.setTranslation(this.current_language.lng_id, labels);
    //   }, err => { })
    // }
  }
  session;
  createAlert(title, summary, details, severity, dismissible, autoDismiss, appendToId) {
    var iconMap = {
      info: "fa fa-info-circle mr-2",
      success: "fa fa-thumbs-up mr-2",
      warning: "fa fa-exclamation-triangle mr-2",
      danger: "fa fa-exclamation-circle mr-2"
    };

    var iconAdded = false;

    var alertClasses = ["alert", "animated", "flipInX"];
    alertClasses.push("alert-" + severity.toLowerCase());
    dismissible = true;
    if (dismissible) {
      alertClasses.push("alert-dismissible");
    }

    var msgIcon = $("<i />", {
      "class": iconMap[severity] // you need to quote "class" since it's a reserved keyword
    });

    var msg = $("<div />", {
      "class": alertClasses.join(" ") // you need to quote "class" since it's a reserved keyword
    });

    if (title) {
      var msgTitle = $("<h4 />", {
        html: title
      }).appendTo(msg);

      if (!iconAdded) {
        msgTitle.prepend(msgIcon);
        iconAdded = true;
      }
    }

    if (summary) {
      var msgSummary = $("<strong />", {
        html: summary
      }).appendTo(msg);

      if (!iconAdded) {
        msgSummary.prepend(msgIcon);
        iconAdded = true;
      }
    }

    if (details) {
      var msgDetails = $("<p />", {
        html: details
      }).appendTo(msg);

      if (!iconAdded) {
        msgDetails.prepend(msgIcon);
        iconAdded = true;
      }
    }


    if (dismissible) {
      var msgClose = $("<span />", {
        "class": "close ml-auto", // you need to quote "class" since it's a reserved keyword
        "data-dismiss": "alert",
        html: "<i class='fa fa-times-circle'></i>"
      }).appendTo(msg);
    }

    $('#' + appendToId).prepend(msg);

    if (autoDismiss) {
      setTimeout(function () {
        msg.addClass("flipOutX");
        setTimeout(function () {
          msg.remove();
        }, 1000);
      }, autoDismiss);
    }
  }
  ngOnInit() {
    //
    this.recallJsFunctions();
    this.closeSideNavRef = this.closeSidenav.bind(this);
    this.sidebar_ref = this.toggleSide.bind(this)
    if (window.innerWidth < 800) {
      this.sidebar_width = '90%'
    }
    this.loader_svc.loader_sub.asObservable().subscribe(res => {
      this.loader = res;
      this.change_detector.detectChanges();
    })
    this.session_svc.getSession().subscribe(res => {
      this.session = res;
      console.log(this.session)
      console.log(this.careerPortalConfig)
      if (res && res.token) {

        this.is_session = 1;

      }
      if (this.session) {
      }
      // if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementAfterLogin) {
      //   this.careerPortalConfig.portalAnnouncementAfterLogin = this.careerPortalConfig.portalAnnouncementAfterLogin.replace("\[username\]", this.session && this.session.userName || '')
      // }
      this.change_detector.detectChanges();
      //
    })
    if (this.session_svc.checkSession()) {
      let code = localStorage.getItem('sellerShortCode');
      if (code && code != '') {
        this.login_service.firstLogin().subscribe(resp => {
          if (resp && resp['status'] && resp['data'] && resp['data'].myJourney) {
            this.router.navigate(['my-journey'])
          }
          // else {
          //   this.navigation(res)
          // }
        }, err => {
          // this.navigation(res)
        })
        // this.profile_settings.searchMaster({
        //   "startPage": 1,
        //   "limit": 1000,
        //   "search": "",
        //   "lastTimeStamp": null
        // }, 'get_city_list', 'cityList').subscribe(res => {
        //   console.log(res)
        // });
      }
      else {
        this.profile_settings.loadDefaultSettings().subscribe(res => {
          if (res && res['data']) {

            if (res && res['data'] && res['data'].companySettingsJson) {
              let portal_details = jsonDeepParse(res['data'].companySettingsJson);
              this.portal_details = portal_details;
              console.log(this.portal_details)
              if (this.portal_details && this.portal_details.portalBackgroundImageArr && this.portal_details.portalBackgroundImageArr.length) {
                this.portal_details['portalBackgroundImage'] = this.portal_details.portalBackgroundImageArr[0].cdnPath
              }
              localStorage.setItem('portal_details', JSON.stringify(this.portal_details));
            }
            if (res['data'].careerPortalConfig) {
              this.portal_details = jsonDeepParse(res['data'].careerPortalConfig.portalSettings);
              this.careerPortalConfig = this.portal_details;
              if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementStyle) {
                this.careerPortalConfig.pportalAnnouncementStyle = this.prepareStyle(this.careerPortalConfig.portalAnnouncementStyle)
                this.customStyle = this.prepareStyle(this.careerPortalConfig.portalAnnouncementStyle);
              }
              if (this.careerPortalConfig && this.careerPortalConfig.autoDisappear) {
                setTimeout(() => {
                  this.timer = 0;
                }, this.careerPortalConfig.autoDisappear)
              }
              if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementAfterLogin) {
                this.careerPortalConfig.portalAnnouncementAfterLogin = this.careerPortalConfig.portalAnnouncementAfterLogin.replace("username", 'Sampat')
              }
              if (this.portal_details && this.portal_details.portalBackgroundImageArr && this.portal_details.portalBackgroundImageArr.length) {
                this.portal_details['portalBackgroundImage'] = this.portal_details.portalBackgroundImageArr[0].cdnPath
              }
              localStorage.setItem('portal_details', JSON.stringify(this.portal_details));
            }
            localStorage.setItem('sellerShortCode', res['data'].sellerShortCode);
            this.login_service.firstLogin().subscribe(resp => {
              if (resp && resp['status'] && resp['data'] && resp['data'].myJourney) {
                this.router.navigate(['my-journey'])
              }
              // else {
              //   this.navigation(res)
              // }
            }, err => {
              // this.navigation(res)
            })
            this.profile_settings.searchMaster({
              "startPage": 1,
              "limit": 1000,
              "search": "",
              "lastTimeStamp": null
            }, 'get_city_list', 'cityList').subscribe(res => {
              console.log(res)
            });
          }
        })
      }
    }

    this.loadMasters();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Check if the current route is '/login'
      if (this.router.url === '/login') {
        this.showNavbar = false;  // Hide navbar on /login route
      } else {
        this.showNavbar = true;  // Show navbar for other routes
      }
    });

  }

  recallJsFunctions() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel)).subscribe(event => {
      $.getScript('../assets/js/custom.js');

      console.log(this.router.url);
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  initFireBase() {
    this.requestPermission();
    this.listen();
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        // Handle the background message payload

        let payload = event.data;
        console.log("Received background message in app component:", payload);
        if (payload && payload.data && payload.data.notificationType) {
          const title = payload && payload.notification && payload.notification.title ? payload.notification.title : 'New Message';
          const options: NotificationOptions = {
            body: payload && payload.notification && payload.notification.body ? payload.notification.body : 'You have received a new message.',
            // Add any other options you want to customize the notification
          };

          this.displayNotification(title, options);
          if (payload.data.notificationTitle) {
            this.notification_srv.success(payload.data.notificationTitle, 'Close', 5000)
          }
          this.prepareMessageFromPayload(payload)
        }

        // Update the app component or trigger any desired functionality
        // ...
      });
    }
  }
  displayNotification(title: string, options: NotificationOptions): void {
    if (Notification.permission === 'granted') {
      // Create and display the notification
      new Notification(title, options);
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          // Create and display the notification
          new Notification(title, options);
        }
      });
    }
  }
  prepareMessageFromPayload(payload) {
    console.log('Message received. ', payload);
    if (this.notificationSound) {
      // Create the audio element
      // try {
      //   var audio = document.createElement('audio');
      //   audio.style.setProperty('display', 'none');
      //   // Set the source of the audio file
      //   audio.src = 'https://storage.googleapis.com/ezeone/icanrefer/' + this.notificationSound;
      //   // Append the audio element to the document body
      //   document.body.appendChild(audio);
      //   // Play the audio
      //   audio.play();
      //   // Add an event listener for the 'ended' event
      //   audio.addEventListener('ended', function () {
      //     console.log('Audio playback completed');
      //     audio.remove();
      //     // Perform any actions you want after the audio playback is finished
      //   });
      // }
      // catch (err) {
      //   console.log(err)
      //   this.playSound()
      // }
      this.playSound()

    }
    if (payload) {
      payload = jsonDeepParse(payload)
    }
    let session: any = sessionStorage.getItem('u');
    let u = jsonParse(decodeURIComponent(atob(session)));
    if (u && u.secretkey && payload && payload.data && payload.data.body) {
      payload.data.body = this.profile_settings.getV3(u.secretkey, payload.data.body);
      if (payload.data.message) {
        this.notification_srv.success(payload.data.message, 'Close', 5000)
      }
      this.profile_settings.setFirebaseMessage(payload);
    }
  }

  playSound() {
    try {
      // Create the audio element
      var audio = document.createElement('audio');

      // Set the source of the audio file
      // audio.src = 'https://storage.googleapis.com/ezeone/icanrefer/' + this.notificationSound;

      // Append the audio element to the document body
      document.body.appendChild(audio);

      // Play the audio
      audio.play();

      // Add an event listener for the 'ended' event
      audio.addEventListener('ended', function () {
        console.log('Audio playback completed');

        // Remove the audio element from the DOM
        audio.remove();
      });
    }
    catch (err) {
      console.log(err)
    }


  }
  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging,
      { vapidKey: environment.firebase.vapidKey }).then(
        (currentToken) => {
          if (currentToken) {
            console.log("Device token");
            console.log(currentToken);
            if (this.is_session) {
              let sfcm = sessionStorage.getItem('fcm');
              if (sfcm && sfcm != currentToken) {
                this.profile_settings.saveFCMKey({
                  gcmid: currentToken
                }).subscribe(res => {
                  if (res && res['data']) {
                    console.log(res['data'])
                  }
                })
              }
              else {
                sessionStorage.setItem('fcm', currentToken)
                this.profile_settings.saveFCMKey({
                  gcmid: currentToken
                }).subscribe(res => {
                  if (res && res['data']) {
                    console.log(res['data'])
                  }
                })
              }
            }
            else {
              sessionStorage.setItem('fcm', currentToken)
            }
          }
          else {
            console.log('No registration token available. Request permission to generate one.');
          }
        }).catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
        });
  }
  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      // this.playSound('assets/notification/notification.wav');
      // this.notification_svc.firebaseNotification(payload.notification, 5000, 'snackbar_class');
      setTimeout(() => {

        // this.loadRights();
      }, 3000);
    });

    // onBackgroundMessage(messaging, (payload) => {
    //   console.log('Message received. ', payload);
    //   this.playSound('assets/notification/notification.wav');
    //   this.notification_svc.firebaseNotification(payload.notification, 5000, 'snackbar_class');
    //   setTimeout(() => {
    //     this.loadRights();
    //   }, 3000);
    // });
  }

  loadMasters() {
    this.profile_settings.loadDefaultSettings().subscribe(res => {
      if (res && res['data']) {
        if (res && res['data'] && res['data'].companySettingsJson) {
          let portal_details = jsonDeepParse(res['data'].companySettingsJson);
          this.portal_details = portal_details;
          console.log(this.portal_details)
          if (this.portal_details && this.portal_details.portalBackgroundImageArr && this.portal_details.portalBackgroundImageArr.length) {
            this.portal_details['portalBackgroundImage'] = this.portal_details.portalBackgroundImageArr[0].cdnPath
          }
          localStorage.setItem('portal_details', JSON.stringify(this.portal_details));
        }
        if (res['data'].careerPortalConfig) {
          this.portal_details = jsonDeepParse(res['data'].careerPortalConfig.portalSettings);
          this.careerPortalConfig = this.portal_details;
          if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementStyle) {
            this.careerPortalConfig.pportalAnnouncementStyle = this.prepareStyle(this.careerPortalConfig.portalAnnouncementStyle)
            this.customStyle = this.prepareStyle(this.careerPortalConfig.portalAnnouncementStyle);
          }
          if (this.careerPortalConfig && this.careerPortalConfig.autoDisappear) {
            setTimeout(() => {
              this.timer = 0;
            }, this.careerPortalConfig.autoDisappear)
          }
          if (this.careerPortalConfig && this.careerPortalConfig.portalAnnouncementAfterLogin) {
            this.careerPortalConfig.portalAnnouncementAfterLogin = this.careerPortalConfig.portalAnnouncementAfterLogin.replace("\[username\]", this.session && this.session.userName || '')
          }
          if (this.portal_details && this.portal_details.portalBackgroundImageArr && this.portal_details.portalBackgroundImageArr.length) {
            this.portal_details['portalBackgroundImage'] = this.portal_details.portalBackgroundImageArr[0].cdnPath
          }
          localStorage.setItem('portal_details', JSON.stringify(this.portal_details));
        }
      }
    })
  }

  setTextDirection() {
    if (this.current_language.rtl == 1) {
      document.head.innerHTML += '<style>*{text-align: right;unicode-bidi: bidi-override;direction: RTL;}</style>';
    }
    else {
      document.head.innerHTML += '<style>*{text-align: left;unicode-bidi: unset;direction: LTR;}</style>';
    }
  }

  languageChanged(param) {

    this.current_language = param;
    this.translate.use(param.lng_id);
    this.setTextDirection();
  }
  getip() {
    return this.http.get('https://ipinfo.io/?token=f411bffc738445', {
      headers: { 'header_type': '2' }
    });
  }

  closeSidenav() {
    if (this.sideNav.opened) {
      this.sideNav.toggle();
    }

  }
  toggleSide(check_open?, navigation_url?, data?) {
    if (check_open) {
      if (this.sidebar.opened) {
        this.sidebar.toggle();
        setTimeout(() => {
          if (navigation_url) {
            this.ng_zone.run(() => {
              this.router.navigate([navigation_url])
            })

          }
        })

      }
    }
    else {
      this.sidebar.toggle();
      if (data) {
        this.data = data;
      }
      setTimeout(() => {
        if (navigation_url) {
          this.ng_zone.run(() => {
            // this.router.navigate(['search'])
            this.router.navigate([navigation_url])
          })

        }
      })
    }
  }

  prepareStyle(a) {
    console.log(a)
    let style = {};
    if (a) {
      a.split(',').forEach(item => { if (item.split(':').length == 2) { style[item.split(':')[0]] = item.split(':')[1] } })
    }
    return style;
  }
  closeAnnoucement() {
    this.timer = 0;
  }
}
export const cloneArray = (items) => {
  if (items && items.length) {
    return items.map(item => Object.assign({}, item));
  }
  else {
    return [];
  }
}

export function sortListSeq(list, sort_selector_property) {
  return list.sort((a, b) => a[sort_selector_property] && a[sort_selector_property].toString().localeCompare(b[sort_selector_property] && b[sort_selector_property].toString()));
}
